import { AUDIO_ELEMENT_CONSTANTS } from 'CONSTANTS/appConstants';
import logger from 'SERVICES/logger';

const checkIfNewAudioElementPresent = (streamName: string) => {
  const audios = document.querySelectorAll(AUDIO_ELEMENT_CONSTANTS.AUDIO);
  let newAudioELe = null;
  if (audios.length !== 0) {
    audios.forEach((audioEle: any) => {
      // check if AUDIO_STREAM_NAME property present or not
      if (audioEle[AUDIO_ELEMENT_CONSTANTS.AUDIO_STREAM_NAME] === undefined) {
        logger.debug('Found new audio element', [audioEle]);
        audioEle[AUDIO_ELEMENT_CONSTANTS.AUDIO_STREAM_NAME] = streamName;
        // TODO : remove time tag in v1.3
        audioEle.TIME = new Date().toString();
        newAudioELe = audioEle;
      }
    });
  }
  return newAudioELe;
};

export const getAudioElements = (streamName: string) => {
  // TODO: reject after some time-out
  return new Promise((resolve) => {
    const targetNode = document.querySelector(AUDIO_ELEMENT_CONSTANTS.BODY_SELECTOR);
    const audioElement = checkIfNewAudioElementPresent(streamName);
    if (audioElement) {
      resolve(audioElement);
      return;
    }
    const config = { childList: true };
    let observer: any = null;
    const callback = (mutationsList: []) => {
      mutationsList.forEach((mutation: any) => {
        if (mutation.type === AUDIO_ELEMENT_CONSTANTS.CHILD_LIST) {
          logger.debug('A child node has been added or removed.');
          const audioEle = checkIfNewAudioElementPresent(streamName);
          if (audioEle) {
            resolve(audioEle);
            observer.disconnect();
          }
        }
      });
    };

    // Create an observer instance linked to the callback function
    observer = new MutationObserver(callback as any);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
  });
};
